import './c-toggle.scss';
import template from './toggle.vhtml';

export default {
	template,
	props: {
		toggleData: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			isSelected: 0,
		};
	},
	methods: {
		toggle( name, id ) {
			if ( this.isSelected === id ) {
				this.isSelected = 0;
				this.$emit( 'selectOption', name, '' );
			} else {
				this.isSelected = id;
				this.$emit( 'selectOption', name, id );
			}
			
		},     
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/toggle/toggle.js